import React from 'react';
import { Redirect } from 'react-router-dom';

import AddOffer from 'App/Admin/Offers/AddOffer';
import EditOffer from 'App/Admin/Offers/EditOffer';
import ViewOffers from 'App/Admin/Offers/ViewOffers/ViewOffers';
import ViewGroupOffers from 'App/Admin/Offers/ViewGroupOffers';
import paths from 'config/local/paths';
import Page from 'shared/Page';
import Switch from 'shared/Switch';
import { translate } from 'App/Internationalization';

export default class Offers extends React.Component {
	render() {
		return (
			<Switch>
				<Redirect
					exact={true}
					from={paths.app.admin.offers.root}
					to={paths.app.admin.offers.view}
				/>
				<Page
					component={ViewOffers}
					path={paths.app.admin.offers.view}
					title={translate('admin.nav.offers.view')}
				/>
				<Page
					component={ViewGroupOffers}
					path={paths.app.admin.offers.groups}
					title={translate('admin.nav.offers.group')}
				/>
				<Page
					component={AddOffer}
					path={paths.app.admin.offers.add}
					title={translate('admin.nav.offers.add')}
				/>
				<Page
					component={EditOffer}
					path={paths.app.admin.offers.edit}
					title={translate('admin.nav.offers.edit')}
				/>
			</Switch>
		);
	}
}
